class MoCartDiscount extends HTMLElement {
  connectedCallback() {
    if (this.boundSubmit) return;
    this.boundSubmit = this.applyDiscount.bind(this);
    this.addEventListener('submit', this.boundSubmit);
  }
  async applyDiscount(event) {
    event.preventDefault();
    const input = this.querySelector('input');
    const button = this.querySelector('button');
    const code = input.value.trim();
    if (!code) return;
    button.disabled = true;
    const drawer = this.closest('cart-drawer');
    const messages = { ...this.dataset };
    try {
      const currentResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      if (!currentResponse.ok) throw new Error('cart');
      const current = await currentResponse.json();
      const codes = (current.discount_codes || []).map(discount => discount.code);
      const combinedCode = [...new Set([...codes, code])].join(',');
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: combinedCode, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
      });
      const state = await response.json();
      if (!response.ok || !state.sections?.['cart-drawer']) throw new Error('cart');
      const allocations = (state.items || []).flatMap(item => item.line_level_discount_allocations || []);
      const discounts = [...(state.cart_level_discount_applications || []), ...allocations.map(a => a.discount_application)];
      const applied = discounts.some(d => d.title?.toLowerCase() === code.toLowerCase());
      drawer.renderContents(state);
      const form = drawer.querySelector('mo-cart-discount');
      form.querySelector('input').value = code;
      form.querySelector('.mo-code__status').textContent = applied ? messages.success : messages.unavailable;
      form.querySelector('input').focus();
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mo-cart-discount', cartData: state });
    } catch (error) {
      this.querySelector('.mo-code__status').textContent = messages.error;
    } finally {
      button.disabled = false;
    }
  }
}
if (!customElements.get('mo-cart-discount')) customElements.define('mo-cart-discount', MoCartDiscount);


